module.exports = __webpack_public_path__ + "static/media/diktat-15.82ca01ca.mp3";